import { formatShortDateWithWeekday, formatTime } from "@clipboard-health/date-time";
import { Pill, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { InterviewStatus } from "@src/appV2/redesign/WorkerShifts/api/useFetchPaginatedInterviews";
import { differenceInMinutes, formatDuration } from "date-fns";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";

interface BookedInterviewCardTitleProps {
  interview: PlacementWithDetails["interviews"][number];
  workerTimezone: string;
}

export function BookedInterviewCardTitle(props: BookedInterviewCardTitleProps) {
  const { interview, workerTimezone } = props;

  const interviewDate = formatShortDateWithWeekday(interview.attributes.start, {
    timeZone: workerTimezone,
  });

  const interviewStartTime = formatTime(interview.attributes.start, {
    timeZone: workerTimezone,
  });
  const interviewEndTime = formatTime(interview.attributes.end, {
    timeZone: workerTimezone,
  });
  const interviewDurationInMinutes = differenceInMinutes(
    new Date(interview.attributes.end),
    new Date(interview.attributes.start)
  );
  const interviewDurationFormatted = formatDuration(
    { minutes: interviewDurationInMinutes },
    { format: ["hours", "minutes"] }
  ).replace("minutes", "mins");

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Text semibold variant="h6">
          Interview on {interviewDate}
        </Text>
        {interview.attributes.status === InterviewStatus.CANCELLED && (
          <Pill
            label="Cancelled"
            variant="outlined-dark"
            iconType="close"
            size="small"
            color={(theme) => theme.palette.error.contrastText}
            backgroundColor={(theme) => theme.palette.error.light}
            iconColor={(theme) => theme.palette.error.contrastText}
          />
        )}
      </Stack>
      <Stack direction="row" alignItems="end" spacing={3}>
        <Text semibold variant="h6">
          {interviewStartTime} - {interviewEndTime}
        </Text>
        <Text variant="body2" sx={{ color: (theme) => theme.palette.text.tertiary }}>
          {interviewDurationFormatted}
        </Text>
      </Stack>
    </>
  );
}
